
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import UnifiedProductForm from '@/components/products/UnifiedProductForm';
import { ArrowLeft } from 'lucide-react';

const CreateUnifiedProduct: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="border-b bg-white">
        <div className="container mx-auto px-4">
          <div className="flex h-16 items-center">
            <Link to="/dashboard" className="flex items-center space-x-2">
              <span className="text-xl font-bold gradient-text">KeepMore</span>
            </Link>
          </div>
        </div>
      </header>
      
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <Button 
            variant="ghost" 
            className="flex items-center text-gray-600 hover:text-keepmore-purple mb-4"
            asChild
          >
            <Link to="/dashboard">
              <ArrowLeft className="h-4 w-4 mr-1" /> Back to Dashboard
            </Link>
          </Button>
          
          <h1 className="text-3xl font-bold mb-1">Create New Product</h1>
          <p className="text-gray-500">Create a one-time product or subscription with a sharable payment link</p>
        </div>
        
        <UnifiedProductForm />
      </main>
    </div>
  );
};

export default CreateUnifiedProduct;
